module.exports = __webpack_public_path__ + "static/media/fire-extinguisher.6c38ab21.svg";